<template>
    <div class="customer-seas-wrap" v-loading="loading">
        <div class="page-filter_wrap">
            <div class="page-filter_wrap_left page-filter_icons" v-if="selectedList && selectedList.length">
                <span
                    >已选中<i>{{ selectedList.length }}</i
                    >项</span
                ><i class="iconfont icon-guanbi_dise cursor" @click="handleRemoveCheckbox"></i>
                <div>
                    <i class="iconfont icon-fenpei" v-if="hasEditPermission" @click="handleChangeDirector(selectedList)">更换负责人</i>
                    <i class="iconfont icon-hebingkehu" v-if="hasEditPermission" @click="handleClickMergeCustomers(selectedList)">合并客户</i>
                    <i class="iconfont icon-shouhui" v-if="hasEditPermission" @click="handleClickRecovery(selectedList)">回收</i>
                    <i class="iconfont icon-shanchu1" v-if="hasDelPermission" @click="handleClickDel(selectedList)">删除</i>
                </div>
            </div>
            <div class="page-filter_wrap_left" v-else>
                <el-input
                    v-model="searchForm.keyword"
                    class="filter-input"
                    clearable
                    placeholder="请输入您想搜索的内容"
                    @clear="handleClickSearch"
                    @keyup.enter.native="handleClickSearch"
                >
                    <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                </el-input>
                <ListAdvancedFiltering
                    :field_form="'customers'"
                    :field_list="fieldsList"
                    :system_fields="systemFilterFields"
                    @sendFilterData="getFilterData"
                />
            </div>
            <div class="page-filter_wrap_right">
                <el-button type="primary" v-if="hasEditPermission" @click="handleClickAdd">新增客户</el-button>
            </div>
        </div>
        <div class="page-content">
            <p class="filter-count" v-if="filterCount && !selectedList.length">共{{ pagination.total }}条</p>
            <CustomVxeTable
                ref="tableRef"
                :class="{ 'custom-table': filterCount && !selectedList.length }"
                :customConfig="tableCustomConfig"
                :empty-render="{ name: 'NotData' }"
                :isShowToolBar="true"
                :pagination.sync="pagination"
                :reduceHeight="reduceHeight"
                :tableData="tableData"
                @handleCurrentChange="handleCurrentChange"
                @handleSizeChange="handleSizeChange"
                @selection-change="selectionChange"
            >
                <vxe-column fixed="left" type="checkbox" width="42"></vxe-column>
                <vxe-column field="related_projects" title="关联商机" width="100" fixed="left">
                    <template #default="{ row }">
                        <el-tooltip
                            content="当前客户未创建商机"
                            effect="dark"
                            placement="top"
                            v-if="row.related_projects && row.related_projects.count === 0"
                        >
                            <div class="relate_icon_wrap is_disabled">
                                <i class="iconfont icon-shangji"></i>
                                <span>商机</span>
                            </div>
                        </el-tooltip>
                        <div
                            @click="
                                handleClickRelateProjectDetail(row.related_projects && row.related_projects.project)
                            "
                            class="relate_icon_wrap"
                            v-if="row.related_projects && row.related_projects.count === 1"
                        >
                            <i class="iconfont icon-shangji"></i>
                            <span>商机</span>
                        </div>
                        <el-popover
                            placement="bottom-start"
                            title=""
                            trigger="click"
                            width="360"
                            :visible-arrow="false"
                            popper-class="custom-tab-popper custom_table_tab_popper"
                        >
                            <div
                                class="relate_icon_wrap"
                                slot="reference"
                                v-if="row.related_projects && row.related_projects.count > 1"
                                @click="handleClickCustomerRelatedProjects(row.id)"
                            >
                                <i class="iconfont icon-shangji"></i>
                                <span>商机</span>
                            </div>
                            <div class="custom-tab-popper-wrap" v-loading="relatedProjectsLoading">
                                <div class="custom-tab-popper-title">
                                    <span>关联商机（{{ related_projects_list.length }}）</span>
                                </div>
                                <div class="custom-tab-popper-content custom-tab-popper-personnel-content">
                                    <ul>
                                        <li
                                            v-for="(item, index) in related_projects_list"
                                            :key="index"
                                            class="business-item"
                                        >
                                            <span
                                                class="link-label ellipsis"
                                                @click="handleClickRelateProjectDetail(item)"
                                                >{{ item.name }}</span
                                            >
                                            <span>{{ item.project_stage && item.project_stage.text }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </el-popover>
                    </template>
                </vxe-column>
                <vxe-column field="related_orders" title="关联订单" width="100" fixed="left">
                    <template #default="{ row }">
                        <el-tooltip
                            content="当前客户未创建订单"
                            effect="dark"
                            placement="top"
                            v-if="row.related_orders && row.related_orders.count === 0"
                        >
                            <div class="relate_icon_wrap is_disabled">
                                <i class="iconfont icon-a-dingdan1"></i>
                                <span>订单</span>
                            </div>
                        </el-tooltip>
                        <div
                            @click="handleClickRelateOrderDetail(row.related_orders && row.related_orders.order)"
                            class="relate_icon_wrap"
                            v-if="row.related_orders && row.related_orders.count === 1"
                        >
                            <i class="iconfont icon-a-dingdan1"></i>
                            <span>订单</span>
                        </div>
                        <el-popover
                            placement="bottom-start"
                            title=""
                            trigger="click"
                            width="360"
                            :visible-arrow="false"
                            popper-class="custom-tab-popper custom_table_tab_popper"
                        >
                            <div
                                class="relate_icon_wrap"
                                slot="reference"
                                v-if="row.related_orders && row.related_orders.count > 1"
                                @click="handleClickCustomerRelatedOrders(row.id)"
                            >
                                <i class="iconfont icon-a-dingdan1"></i>
                                <span>订单</span>
                            </div>

                            <div class="custom-tab-popper-wrap" v-loading="relatedOrdersLoading">
                                <div class="custom-tab-popper-title">
                                    <span>关联订单（{{ related_orders_list.length }}）</span>
                                </div>
                                <div class="custom-tab-popper-content custom-tab-popper-order-content">
                                    <ul>
                                        <li
                                            v-for="(item, index) in related_orders_list"
                                            :key="index"
                                            class="order-item"
                                        >
                                            <div class="order-item-title">
                                                <span class="link-label ellipsis" @click="handleClickRelateOrderDetail(item)">{{ item.order_num }}</span>
                                                <span>{{ item.created_at }}</span>
                                            </div>
                                            <div class="order-item-content">
                                                <PersonnelCard :userId="item.salesperson" v-if="item.salesperson">
                                                    <template slot="container">
                                                        <div class="user-avatar-btn">
                                                            <img
                                                                alt=""
                                                                :src="
                                                                    item.salesperson_avatar
                                                                        ? item.salesperson_avatar
                                                                        : defaultImg
                                                                "
                                                            />
                                                            <span>{{ item.salesperson_name }}</span>
                                                        </div>
                                                    </template>
                                                </PersonnelCard>
                                                <span>¥{{ item.total_price }}</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </el-popover>
                    </template>
                </vxe-column>
                <vxe-column field="name" title="客户名称" fixed="left" min-width="260" show-overflow>
                    <template #default="{ row }">
                        <span class="link-label" @click="handleClickCompanyDetail(row)">{{ row.name.value }}</span>
                    </template>
                </vxe-column>
                <vxe-column
                    v-for="(field, index) in fieldsList"
                    :key="field.field_key"
                    :align="field.align ? 'right' : 'left'"
                    :header-align="field.align ? 'right' : 'left'"
                    :field="field.field_key"
                    show-overflow
                    :title="field.field_name"
                    :min-width="getFieldWidth(field.field_type)"
                >
                    <template #header>
                        <div class="table_field_label">
                            <span v-text="field.field_name"></span>
                        </div>
                    </template>
                    <template #default="{ row }">
                        <div v-if="field.field_type === 'customer_contact'">
                            <RelatedContacts
                                v-if="row[field.field_key] && row[field.field_key].length"
                                :contactInfos="row[field.field_key]"
                                :isPhoneEncryption="false"
                            />
                        </div>
                        <div v-else-if="field.field_type === 'contact'">
                            <div v-if="row[field.field_key].length">
                                <div v-for="item in row[field.field_key]" class="custom_contact_field_wrap">
                                    <PersonnelCard :userId="item.id" v-if="item.id">
                                        <template slot="container">
                                            <img :src="item.avatar ? item.avatar : defaultImg" alt="" class="avatar" />
                                            <span class="name" v-text="item.name"></span>
                                        </template>
                                    </PersonnelCard>
                                </div>
                            </div>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'department'">
                            <div v-if="row[field.field_key].length">
                                <div v-for="item in row[field.field_key]">
                                    <el-tooltip :content="item.full_path" effect="dark" placement="top">
                                        <span v-text="item.department_name"></span>
                                    </el-tooltip>
                                </div>
                            </div>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'radio'">
                            <span
                                v-if="row[field.field_key]"
                                :class="{ is_tag_interaction: field.extend.tag_interaction }"
                                v-text="row[field.field_key]"
                            ></span>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'checkbox'">
                            <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                <template v-if="field.extend.tag_interaction">
                                    <span
                                        v-for="item in row[field.field_key].slice(0, 2)"
                                        :class="{ is_tag_interaction: field.extend.tag_interaction }"
                                        v-text="item"
                                    >
                                    </span>
                                    <span class="is_tag_interaction">+{{ row[field.field_key].length }}</span>
                                </template>
                                <template v-else>
                                    <span>{{ row[field.field_key].join(",") }} </span>
                                </template>
                            </div>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'checkbox_user_tag'">
                            <div v-if="row[field.field_key].length" class="custom_checkbox_field_wrap">
                                <span
                                    v-for="item in row[field.field_key]"
                                    class="is_tag_interaction"
                                    v-text="item.name"
                                >
                                </span>
                            </div>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'image'">
                            <div v-if="row[field.field_key].length" class="table_custom_image_wrap">
                                <el-image
                                    :preview-src-list="row[field.field_key].map((img) => img.file_path)"
                                    :src="row[field.field_key][0].file_path"
                                    fit="cover"
                                >
                                </el-image>
                                <el-popover
                                    :visible-arrow="false"
                                    placement="bottom-start"
                                    popper-class="table_custom_image_popover"
                                    title=""
                                    trigger="hover"
                                    width="254"
                                >
                                    <div slot="reference">
                                        <span
                                            v-if="row[field.field_key].length > 1"
                                            class="image_count"
                                            v-text="`+${row[field.field_key].length - 1}`"
                                        ></span>
                                    </div>
                                    <ul class="image_list">
                                        <li
                                            v-for="(img, img_index) in row[field.field_key]"
                                            :key="img_index"
                                            class="image_item"
                                        >
                                            <el-image
                                                :preview-src-list="row[field.field_key].map((img) => img.file_path)"
                                                :src="img.file_path"
                                                fit="cover"
                                            >
                                            </el-image>
                                        </li>
                                    </ul>
                                </el-popover>
                            </div>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'file'">
                            <div v-if="row[field.field_key].length" class="custom_list_file_field_wrap">
                                <el-popover
                                    placement="bottom"
                                    popper-class="id_card_detail_popper"
                                    trigger="click"
                                    width="456"
                                >
                                    <span slot="reference" class="link-label">
                                        {{ row[field.field_key][0].file_name
                                        }}{{ row[field.field_key].length > 1 ? row[field.field_key].length - 1 : "" }}
                                    </span>
                                    <ul class="upload_file_list upload_file_list_detail">
                                        <li v-for="file in row[field.field_key]" class="upload_file_item">
                                            <div class="file_left_wrap">
                                                <img
                                                    alt=""
                                                    class="file_img"
                                                    src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                                />
                                                <div class="file_info_wrap">
                                                    <p class="file_name" v-text="file.file_name"></p>
                                                    <p class="file_size" v-text="file.file_size"></p>
                                                </div>
                                            </div>
                                            <div class="file_right_wrap">
                                                <el-tooltip content="预览" effect="dark" placement="top">
                                                    <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                        <i class="iconfont icon-yanjing"></i>
                                                    </span>
                                                </el-tooltip>
                                                <span class="line"></span>
                                                <el-tooltip content="下载" effect="dark" placement="top">
                                                    <span
                                                        class="handle_icon_wrap"
                                                        @click="handleClickDownloadFile(file)"
                                                    >
                                                        <i class="iconfont icon-daochu"></i>
                                                    </span>
                                                </el-tooltip>
                                            </div>
                                        </li>
                                    </ul>
                                </el-popover>
                            </div>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'invoice'">
                            <div v-if="row[field.field_key].length" class="custom_list_file_field_wrap">
                                <el-popover
                                    placement="bottom"
                                    popper-class="id_card_detail_popper"
                                    trigger="click"
                                    width="456"
                                >
                                    <span slot="reference" class="link-label">
                                        {{ row[field.field_key][0].purchaser_name
                                        }}{{ row[field.field_key].length > 1 ? row[field.field_key].length - 1 : "" }}
                                    </span>
                                    <ul class="upload_file_list upload_file_list_detail">
                                        <li v-for="file in row[field.field_key]" class="upload_file_item">
                                            <div class="file_left_wrap">
                                                <img
                                                    alt=""
                                                    class="file_img"
                                                    src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                                />
                                                <div class="file_info_wrap">
                                                    <p class="file_name" v-text="file.purchaser_name"></p>
                                                    <p class="file_size" v-text="file.file_size"></p>
                                                </div>
                                            </div>
                                            <div class="file_right_wrap">
                                                <el-tooltip content="预览" effect="dark" placement="top">
                                                    <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                        <i class="iconfont icon-yanjing"></i>
                                                    </span>
                                                </el-tooltip>
                                                <span class="line"></span>
                                                <el-tooltip content="下载" effect="dark" placement="top">
                                                    <span
                                                        class="handle_icon_wrap"
                                                        @click="handleClickDownloadFile(file)"
                                                    >
                                                        <i class="iconfont icon-daochu"></i>
                                                    </span>
                                                </el-tooltip>
                                            </div>
                                        </li>
                                    </ul>
                                </el-popover>
                            </div>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'relate_approve_form'"></div>
                        <div v-else-if="field.field_type === 'id_card'">
                            <div v-if="row[field.field_key].value" class="custom_id_card_field_wrap">
                                <span v-text="row[field.field_key].value"></span>
                                <el-popover
                                    placement="bottom"
                                    popper-class="id_card_detail_popper"
                                    trigger="click"
                                    width="380"
                                >
                                    <span slot="reference" class="handle_icon_wrap" style="margin-left: 10px">
                                        <i class="iconfont icon-shenfenzheng"></i>
                                    </span>
                                    <el-form size="small">
                                        <el-row>
                                            <el-col :span="24">
                                                <el-form-item v-if="row[field.field_key].name" label="姓名" prop="name">
                                                    <span v-text="row[field.field_key].name"></span>
                                                </el-form-item> </el-col
                                            ><br />
                                            <el-col :span="24">
                                                <el-form-item
                                                    v-if="row[field.field_key].birthday"
                                                    label="出生日期"
                                                    prop="birthday"
                                                >
                                                    <span v-text="row[field.field_key].birthday"></span>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24">
                                                <el-form-item
                                                    v-if="row[field.field_key].address"
                                                    label="家庭住址"
                                                    prop="name"
                                                >
                                                    <span v-text="row[field.field_key].address"></span>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="24">
                                                <el-form-item label="身份证号" prop="value">
                                                    <span v-text="row[field.field_key].value"></span>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-form>
                                    <img
                                        alt=""
                                        class="ic_card_icon"
                                        src="https://download.hecoos.com/enlightv/2025-02/02d922ef5bd0a7ded22b965632d634ea.png"
                                    />
                                </el-popover>
                            </div>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'paying_teller'">
                            <div
                                v-if="row[field.field_key] && row[field.field_key].text"
                                class="custom_paying_teller_field_wrap"
                            >
                                <span v-text="row[field.field_key].text"></span>
                                <el-popover
                                    placement="bottom"
                                    popper-class="paying_teller_detail_popper"
                                    trigger="click"
                                    width="350"
                                >
                                    <span slot="reference" class="handle_icon_wrap">
                                        <i class="iconfont icon-zhanghu"></i>
                                    </span>
                                    <el-form class="custom_detail_form" label-position="top" size="small">
                                        <el-form-item label="账户类型" prop="account_type">
                                            <span
                                                v-text="
                                                    row[field.field_key].account_type === 1 ? '个人账户' : '对公账户'
                                                "
                                            ></span>
                                        </el-form-item>
                                        <el-form-item label="户名" prop="account_name">
                                            <span v-text="row[field.field_key].account_name"></span>
                                        </el-form-item>
                                        <el-form-item label="账号" prop="card_number">
                                            <span v-text="row[field.field_key].card_number"></span>
                                        </el-form-item>
                                        <el-form-item label="所属银行" prop="bank_name">
                                            <span v-text="row[field.field_key].bank_name"></span>
                                        </el-form-item>
                                        <el-form-item
                                            v-if="field.extend.bank_branch_is_show"
                                            label="银行支行"
                                            prop="bank_branch"
                                        >
                                            <span v-text="row[field.field_key].bank_branch"></span>
                                        </el-form-item>
                                    </el-form>
                                </el-popover>
                            </div>
                            <span v-else>--</span>
                        </div>
                        <div v-else-if="field.field_type === 'table'"></div>
                        <div v-else-if="field.field_type === 'checkbox_approval'"></div>
                        <span v-else v-text="row[field.field_key] ? row[field.field_key] : '--'"></span>
                    </template>
                </vxe-column>
                <vxe-column field="operate" width="90" fixed="right">
                    <template #header>
                        <span>操作</span>
                        <el-tooltip class="item" effect="dark" content="表头设置" placement="bottom-start">
                            <i class="iconfont icon-biaotoushezhi table-header-icon" @click="handleClickCustom"></i>
                        </el-tooltip>
                    </template>
                    <template #default="{ row }">
                        <div class="table-operate-icon">
                            <el-tooltip effect="dark" content="编辑" placement="top" v-if="hasEditPermission"
                                ><i class="iconfont icon-bianji" @click="handleClickEdit(row)"></i
                            ></el-tooltip>
                            <el-dropdown placement="bottom-end" trigger="click">
                                <el-tooltip effect="dark" content="更多" placement="top"
                                    ><i class="iconfont el-icon-more"></i
                                ></el-tooltip>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-if="hasEditPermission" @click.native="handleChangeDirector(row, 'item')">
                                        更换负责人
                                    </el-dropdown-item>
                                    <el-dropdown-item v-if="hasEditPermission" @click.native="handleClickRecovery(row, 'item')">
                                        回收
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native="handleClickShare(row, 'item')">
                                        分享
                                    </el-dropdown-item>
                                    <el-dropdown-item v-if="hasDelPermission" @click.native="handleClickDel(row, 'item')">
                                        删除
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </template>
                </vxe-column>
                <template #empty>
                    <div class="custom-table-empty">
                        <div class="custom-table-empty-img">
                            <img
                                src="https://download.hecoos.com/enlightv/2025-09/904b1eff0ee89688f6d0725316c6cb39.png"
                                alt=""
                            />
                        </div>
                        <p class="empty_desc">暂无客户，可以选择新增客户添加，或前往公海申领</p>
                        <div style="margin-top: 32px">
                            <el-button type="primary" plain size="small" @click="handleClickHighSeasAdd"
                                >前往公海申领
                            </el-button>
                            <el-button size="small" type="primary" v-if="hasEditPermission" @click="handleClickAdd">新增客户</el-button>
                        </div>
                    </div>
                </template>
            </CustomVxeTable>
        </div>

        <el-dialog
            v-if="deleteCustomerDialog"
            :before-close="handledeleteCustomerDialogClose"
            :close-on-click-modal="false"
            :visible.sync="deleteCustomerDialog"
            class="custom-dialog custom-tooltip-confirm-dialog"
            title=""
            width="390px"
        >
            <div class="flex">
                <i class="dialog-left-icon iconfont icon-jinggao"></i>
                <div>
                    <p class="tooltip-confirm-title">您确定要删除吗？</p>
                    <p>删除后不可恢复，请谨慎操作！</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handledeleteCustomerDialogClose">取消</el-button>
                <el-button type="danger" @click="handledeleteCustomerConfirm">删除</el-button>
            </span>
        </el-dialog>
        <CustomerAdd
            v-if="addDialogVisible"
            :addDialogVisible.sync="addDialogVisible"
            :editId="editId"
            @operateSuccessCallback="getTableData"
        />
        <DirectorChange
            v-if="directorChangeVisible"
            :directorChangeVisible.sync="directorChangeVisible"
            :selectedList="selectedTableData"
            @updateCallback="handleUpdateCallback"
        />
        <CustomerRecovery
            v-if="customerRecoveryVisible"
            :customerRecoveryVisible.sync="customerRecoveryVisible"
            :selectedList="selectedTableData"
            @updateCallback="handleUpdateCallback"
        />
        <CustomerMerge
            v-if="customerMergeVisible"
            :customerMergeVisible.sync="customerMergeVisible"
            :customer_ids="mergeCustomerIds"
            @updateCallback="handleUpdateCallback"
        />
        <ShareDialog
            v-if="shareDialog"
            :shareCustomerId="shareCustomerId"
            :shareCustomerName="shareCustomerName"
            :shareDialog.sync="shareDialog"
        />
        <!-- 从消息点击进来的 -->
        <el-dialog
            v-if="messageCustomerDialog"
            :before-close="handleMessageCustomerDialogClose"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :modal-append-to-body="false"
            :visible.sync="messageCustomerDialog"
            class="custom-dialog custom-message-notice-dialog"
            :title="messageNoticeTitle"
            width="462px"
        >
            <ul class="message_notice_box">
                <li v-for="(row, rowIndex) in messageNoticeTableData" :key="rowIndex" @click="handleClickNoticeCompanyDetail(row)">
                    <p class="ellipsis">{{ row.name }}</p><span class="link-label">详情</span>
                </li>
            </ul>
        </el-dialog>
        <el-image ref="preview_img" :preview-src-list="previewImgList" :src="previewImgSrc" style="display: none">
        </el-image>
    </div>
</template>
<script>
import { pagination } from "@/mixins";
import { GetCustomerPrivateList, CustomerPrivateDel, getFormFields, getProjectList, getOrderList , CustomerPopupList} from "@/api";
import { tableDataFieldShow } from "@/utils";
import { getOSSData } from "@/utils/uploadOss";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import ListAdvancedFiltering from "@/components/pComponents/ListAdvancedFiltering";
import CustomerAdd from "./component/customer_add.vue";
import DirectorChange from "./component/director_change.vue";
import CustomerRecovery from "./component/customer_recovery.vue";
import CustomerMerge from "./component/customer_merge.vue";
import ShareDialog from "./component/share_dialog.vue";
import RelatedContacts from "@/components/pComponents/RelatedContacts.vue";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
import {mapGetters} from "vuex";

export default {
    name: "CustomerPrivateSeas",
    components: {
        ListAdvancedFiltering,
        CustomVxeTable,
        CustomerAdd,
        DirectorChange,
        CustomerRecovery,
        CustomerMerge,
        ShareDialog,
        RelatedContacts,
        PersonnelCard,
    },
    data() {
        return {
            loading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            searchForm: {
                keyword: "",
                type: 1,
            },
            filterForm: {
                content: [
                    {
                        label: "",
                        meet: 1,
                        value: "",
                        common: false,
                    },
                ],
            },
            fieldsList: [],
            tableData: [],
            is_related_order: false, // 是否有关联订单
            is_related_project: false, // 是否有关联商机
            selectedList: [], // 复选框选中
            editId: "", // 编辑客户
            addDialogVisible: false, // 添加、编辑
            directorChangeVisible: false, // 更换负责人
            customerRecoveryVisible: false, // 回收
            customerMergeVisible: false, // 合并客户
            deleteId: "",
            deleteCustomerDialog: false, // 删除
            selectedTableData: [], // 弹框需要 复选框选中的数据
            shareCustomerId: "", // 分享客户id
            shareCustomerName: "", // 分享客户名称
            shareDialog: false, // 分享
            tableCustomConfig: {
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return col.column.type !== "checkbox";
                },
                checkMethod: (col) => {
                    return col.column.field !== "name";
                },
                allowSort: true,
            },
            mergeCustomerIds: [],
            systemFilterFields: [],
            custom_filter: {},
            // 附件预览
            previewImgList: [],
            previewImgSrc: "",

            // 关联的商机
            relatedProjectsLoading: false,
            related_projects_list: [],
            // 关联订单
            relatedOrdersLoading: false,
            related_orders_list: [],
            // 消息进来查看的客户
            messageCustomerDialog: false,
            messageNoticeTitle: "消息通知",
            messageNoticeTableData: []
        };
    },
    mixins: [pagination],
    computed: {
        filterCount() {
            const list = this.filterForm.content;
            return list.filter((item) => item.value).length;
        },
        reduceHeight() {
            return this.filterCount ? 200 : this.tableData.length ? 170 : 120;
        },
        ...mapGetters(['hasPermission']),
        // 编辑权限，可对客户信息新增、编辑、更换客户负责人、回收及合并客户
        hasEditPermission() {
            return this.hasPermission('customerPrivate.edit', 'customer', 'CustomerPrivateSeas');
        },
        // 删除权限
        hasDelPermission() {
            return this.hasPermission('customerPrivate.del', 'customer', 'CustomerPrivateSeas');
        },
    },
    created() {
        this.getFieldList();
        if(this.$route.query && this.$route.query.customer_ids) {
            this.messageNoticeTitle = this.$route.query.title || "-"
            this.getMessageNoticeData()
        }
    },
    methods: {
        // 读取缓存
        getLocalStorageFunction() {
            let localStorageData = localStorage.getItem("privateSeasListLocalStorage");
            if (localStorageData) {
                localStorageData = JSON.parse(localStorageData);
                this.searchForm = localStorageData.searchForm;
                this.pagination.pageNum = localStorageData.pagination.pageNum;
                this.pagination.pageSize = localStorageData.pagination.pageSize;
            }
            this.getTableData();
            localStorage.removeItem("privateSeasListLocalStorage");
        },
        // 写入缓存
        setLocalStorageFunction() {
            const data = {
                searchForm: this.searchForm,
                pagination: {
                    pageNum: this.pagination.pageNum,
                    pageSize: this.pagination.pageSize,
                },
            };
            localStorage.setItem("privateSeasListLocalStorage", JSON.stringify(data));
        },
        // 表头配置
        handleClickCustom() {
            this.$refs.tableRef.handleOpenCustomShow();
        },
        // 表格复选框
        selectionChange(ids) {
            this.selectedList = ids;
        },
        // 清空复选框选中
        handleRemoveCheckbox() {
            this.selectedList = [];
            this.$refs.tableRef.removeCheckboxRow();
        },
        // 前往公海申领
        handleClickHighSeasAdd() {
            this.$router.push({
                name: "CustomerHighSeas",
                params: {
                    isPush: true,
                },
                query: {
                    type: "add",
                },
            });
        },
        handleClickAdd() {
            this.editId = "";
            this.addDialogVisible = true;
        },
        handleClickEdit({ id }) {
            this.editId = String(id);
            this.addDialogVisible = true;
        },
        // 查看公司详情
        handleClickCompanyDetail({ id, name }) {
            this.setLocalStorageFunction();
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: id,
                    name: name.value,
                },
            });
        },
        // 查看关联商机详情
        handleClickRelateProjectDetail(row) {
            this.$router.push({
                name: "BusinessDetail",
                query: {
                    project_id: row.project_id,
                    name: row.name,
                },
                params: {
                    isPush: true,
                },
            });
        },
        // 关联订单详情
        handleClickRelateOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.order_id ? row.order_id : undefined,
                    order_num: row.order_no ? row.order_no : undefined,
                    name: row.order_num ? row.order_num : row.order_no,
                    query_type: row.order_id ? undefined : "order_num",
                },
            });
        },
        // 合并客户
        handleClickMergeCustomers(list, type) {
            if (list.length === 0) return this.$message.error("请选择需要合并的客户");
            if (list.length === 1) return this.$message.error("请至少选择两个客户");
            this.mergeCustomerIds = list.map((item) => item.id);
            this.customerMergeVisible = true;
        },
        // 更换负责人
        handleChangeDirector(list, type) {
            this.selectedTableData = type == "item" ? [list] : list;
            this.directorChangeVisible = true;
        },
        // 处理操作之后
        handleUpdateCallback() {
            this.selectedList = [];
            this.getTableData();
        },
        // 回收
        handleClickRecovery(list, type) {
            this.selectedTableData = type == "item" ? [list] : list;
            this.customerRecoveryVisible = true;
        },
        // 分享
        handleClickShare(row) {
            this.shareCustomerId = row.id;
            this.shareCustomerName = row.name && row.name.value;
            this.shareDialog = true;
        },
        // 删除
        handleClickDel(data, type) {
            this.deleteId = type == "item" ? [data.id] : data.map((item) => item.id);
            this.deleteCustomerDialog = true;
        },
        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes("image")) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.includes("pdf")) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name || file.purchaser_name);
        },
        handledeleteCustomerDialogClose() {
            this.deleteId = "";
            this.deleteCustomerDialog = false;
        },
        handledeleteCustomerConfirm() {
            CustomerPrivateDel({ customer_ids: this.deleteId }).then((res) => {
                if (res.code === 200) {
                    this.$message.success(res.message);
                    this.deleteCustomerDialog = false;
                    this.handleUpdateCallback();
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 筛选
        handleClickSearch() {
            this.pagination.pageNum = 1;
            this.getTableData();
        },
        // 获取高级筛选数据
        getFilterData(data) {
            this.custom_filter = data;
            this.handleClickSearch();
        },
        // 页码改变
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.getTableData();
        },
        // 页数改变
        handleSizeChange(page) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = page.pageSize;
            this.getTableData();
        },
        getFieldList() {
            getFormFields({
                field_form: "customers",
                filter_field_type: "",
            }).then((res) => {
                if (res.code === 200) {
                    this.fieldsList = [];
                    res.data.forEach((field) => {
                        // this.calculateTableWidth(field, [field.field_name]);

                        if (field.field_type === "control") {
                        } else {
                            if (
                                field.field_key !== "name" &&
                                field.field_key !== "related_order" &&
                                field.field_key !== "related_project"
                            ) {
                                this.fieldsList.push(field);
                            }
                        }
                    });
                    this.is_related_project = res.data.includes((item) => item.field_key == "related_project");
                    this.is_related_order = res.data.includes((item) => item.field_key == "related_order");
                    // 判断是否有关联订单和商机
                    this.getLocalStorageFunction();
                }
            });
        },
        // 计算文本宽度
        calculateTableWidth(field, textData) {
            let widthData = [];
            textData.forEach((item, key) => {
                // 创建一个新的 span 元素
                const span = document.createElement("span");
                // 设置 span 元素的样式
                span.style.fontSize = "16px";
                // 设置 span 元素的内容
                span.textContent = item;
                // 将 span 元素添加到页面中
                document.body.appendChild(span);
                // 获取 span 元素的宽度
                const width = span.offsetWidth;

                widthData.push(width);
                // 从页面中删除 span 元素
                span.remove();
            });
            var max = Math.max(...widthData);
            max = max + 42;
            this.$set(field, "table_column_width", max > 300 ? 300 : max);
        },
        getFieldWidth(field_type) {
            if (field_type == "id_card" || field_type === "paying_teller" || field_type === "file") {
                return "210";
            } else if (field_type == "checkbox") {
                return "160";
            } else {
                return "150";
            }
        },
        getTableData() {
            this.loading = true;
            GetCustomerPrivateList({
                keyword: this.searchForm.keyword,
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                custom_filter: this.custom_filter,
            })
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        this.tableData = data || [];
                        this.pagination.total = total;
                        tableDataFieldShow(this.fieldsList, data);
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 获取关联工单
        handleClickCustomerRelatedProjects(customer_id) {
            this.relatedProjectsLoading = true
            getProjectList({
                keyword: "",
                page: 1,
                pageSize: 100,
                customer_id,
            })
                .then((res) => {
                    if (res.code === 200) {
                        this.related_projects_list = res.data.data || [];
                    }
                    this.relatedProjectsLoading = false
                })
                .catch(() => {
                    this.relatedProjectsLoading = false
                });
        },
        // 获取关联订单
        handleClickCustomerRelatedOrders(customer_id) {
            this.relatedOrdersLoading = true
            getOrderList({
                page: 1,
                pageSize: 100,
                keyword: "",
                customer_id,
            }).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    this.related_orders_list = data || [];
                }
                this.relatedOrdersLoading = false
            }).catch(()=> {
                this.relatedOrdersLoading = false
            })
        },
        // 查看消息通知
        getMessageNoticeData() {
            const ids = this.$route.query && this.$route.query.customer_ids;
            CustomerPopupList({customer_ids: ids}).then(res=> {
                if(res.code === 200) {
                    this.messageNoticeTableData = res.data || [];
                    this.messageCustomerDialog = true;
                }
            })
        },
        // 消息关联的客户弹框关闭
        handleMessageCustomerDialogClose() {
            this.messageCustomerDialog = false;
        },
        // 查看消息通知客户详情
        handleClickNoticeCompanyDetail({ id, name }) {
            this.setLocalStorageFunction();
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: id,
                    name,
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/styles/customer-seas-detail.scss";
.customer-seas-wrap {
    padding: 16px;

    .custom-tooltip-icon {
        margin-right: 4px;
    }

    .filter-count {
        margin-top: 16px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
    }

    .custom-table {
        ::v-deep {
            .vxe-table {
                margin-top: 8px;
            }
        }
    }

    .relate_icon_wrap {
        display: inline-block;
        vertical-align: top;
        padding: 0 4px;
        font-size: 14px;
        height: 24px;
        line-height: 24px;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;

        .iconfont {
            color: rgba(102, 102, 102, 1);
            margin-right: 4px;
            font-size: 14px;
        }

        &.is_disabled {
            color: rgba(191, 191, 191, 1);

            .iconfont {
                color: rgba(191, 191, 191, 1);
            }
        }

        &:not(.is_disabled) {
            &:hover {
                &:hover {
                    border-radius: 4px;
                    background: rgba(0, 0, 0, 0.04);
                    color: rgba(51, 51, 51, 1);
                }
            }
        }
    }
}
.crm_contact_table {
    padding: 16px;
}
</style>
<style lang="scss">
.custom-message-notice-dialog {
    .el-dialog__header {
        border-bottom: none;
    }
    .el-dialog__body {
        padding: 0 0 16px;
    }
}
.custom_table_tab_popper {
    padding: 0 !important;
    height: 360px;
    .custom-tab-popper-wrap {
        height: 360px;
    }
}
@import "@/styles/filter-form-wrap.scss";
</style>
